/**
 * Custom JavaScript for Carbon Driver (Focal theme)
 *
 * Focal documentation: events 'variant:changed', 'variant:added', 'cart:updated', 'cart:refresh',
 * custom elements <drawer-content>, document.getElementById('mini-cart').open = true, etc.
 */

/**
 * BSS Product Options : rester sur la page produit après "Add to cart".
 *
 * L'app BSS ajoute l'article en AJAX puis, comme elle ne connaît pas le tiroir panier de Focal,
 * redirige vers /cart. Elle expose le hook bssFixSupportCustomAfterAddToCart : s'il est défini,
 * il est appelé à la place de la redirection. On rafraîchit le mini-panier Focal et on l'ouvre.
 */
window.bssFixSupportCustomAfterAddToCart = function (bss, cartResponse, button, loadingState) {
  try {
    bss.helper.removeLoadingBtnCSS(button, loadingState);
  } catch (e) {}

  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  var miniCart = document.getElementById('mini-cart');
  if (miniCart) {
    setTimeout(function () { miniCart.open = true; }, 300);
  }

  return cartResponse;
};
